import "core-js/modules/es6.function.name";
import "core-js/modules/es6.string.link";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.array.is-array";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";
import React, { useState } from 'react';
import { arrayOf, oneOf, oneOfType, string, number, node, shape } from 'prop-types';
import { Badge, Box, Flex, Link, useThemeUI, Text, Grid, Button, Container, Heading, Close, MenuButton, AspectRatio } from 'theme-ui';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
} // Takes a value of type responsiveAligType and normalizes it to Flexbox compatible values.


var normalizeAlign = function normalizeAlign(align) {
  var alignments = {
    start: 'flex-start',
    center: 'center',
    end: 'flex-end'
  };

  if (Array.isArray(align)) {
    return align.map(function (alignment) {
      return alignments[alignment];
    });
  }

  return alignments[align];
}; // Neutralize outer margins with negative margins on Flex.


var Badges = function Badges(_ref) {
  var values = _ref.values,
      _ref$align = _ref.align,
      align = _ref$align === void 0 ? 'start' : _ref$align,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'primary' : _ref$variant,
      props = _objectWithoutProperties(_ref, ["values", "align", "variant"]);

  return React.createElement(Box, props, React.createElement(Flex, {
    sx: {
      flexWrap: 'wrap',
      justifyContent: normalizeAlign(align)
    },
    m: -1
  }, values.map(function (value) {
    return React.createElement(Badge, {
      key: value,
      sx: {
        m: 1
      },
      variant: variant
    }, value);
  })));
};

var alignments = ['start', 'center', 'end'];
var alignType = oneOf(alignments); // You can add your own variants applications.

Badges.propTypes = {
  values: arrayOf(string).isRequired,
  align: oneOfType([alignType, arrayOf(alignType)]),
  variant: string
};

var Icon = function Icon(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 32 : _ref$size,
      props = _objectWithoutProperties(_ref, ["size"]);

  return React.createElement(Box, _extends({}, props, {
    sx: {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 1,
      width: size,
      height: size,
      color: 'inherit',
      bg: 'transparent'
    }
  }));
};

Icon.propTypes = {
  size: oneOfType([number, arrayOf(number)])
};

var EmailIcon = function EmailIcon(_ref) {
  var size = _ref.size,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["size", "title"]);

  return React.createElement(Icon, _extends({}, props, {
    size: size,
    "aria-label": "E-mail icon"
  }), React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    height: "100%",
    width: "100%",
    fill: "currentColor",
    viewBox: "0 0 14 10"
  }, title && React.createElement("title", null, title), React.createElement("path", {
    d: "M0 1V9C0 9.55 0.45 10 1 10H13C13.55 10 14 9.55 14 9V1C14 0.45 13.55 0 13 0H1C0.45 0 0 0.45 0 1ZM13 1L7 6L1 1H13ZM1 2.5L5 5.5L1 8.5V2.5ZM2 9L5.5 6L7 7.5L8.5 6L12 9H2ZM13 8.5L9 5.5L13 2.5V8.5Z"
  })));
};

EmailIcon.propTypes = {
  size: oneOfType([number, arrayOf(number)]),
  title: string
};

var GitHubIcon = function GitHubIcon(_ref) {
  var size = _ref.size,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["size", "title"]);

  return React.createElement(Icon, _extends({}, props, {
    size: size,
    "aria-label": "GitHub icon"
  }), React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    height: "100%",
    width: "100%",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, title && React.createElement("title", null, title), React.createElement("path", {
    d: "M12 0.296997C5.37 0.296997 0 5.67 0 12.297C0 17.6 3.438 22.097 8.205 23.682C8.805 23.795 9.025 23.424 9.025 23.105C9.025 22.82 9.015 22.065 9.01 21.065C5.672 21.789 4.968 19.455 4.968 19.455C4.422 18.07 3.633 17.7 3.633 17.7C2.546 16.956 3.717 16.971 3.717 16.971C4.922 17.055 5.555 18.207 5.555 18.207C6.625 20.042 8.364 19.512 9.05 19.205C9.158 18.429 9.467 17.9 9.81 17.6C7.145 17.3 4.344 16.268 4.344 11.67C4.344 10.36 4.809 9.29 5.579 8.45C5.444 8.147 5.039 6.927 5.684 5.274C5.684 5.274 6.689 4.952 8.984 6.504C9.944 6.237 10.964 6.105 11.984 6.099C13.004 6.105 14.024 6.237 14.984 6.504C17.264 4.952 18.269 5.274 18.269 5.274C18.914 6.927 18.509 8.147 18.389 8.45C19.154 9.29 19.619 10.36 19.619 11.67C19.619 16.28 16.814 17.295 14.144 17.59C14.564 17.95 14.954 18.686 14.954 19.81C14.954 21.416 14.939 22.706 14.939 23.096C14.939 23.411 15.149 23.786 15.764 23.666C20.565 22.092 24 17.592 24 12.297C24 5.67 18.627 0.296997 12 0.296997"
  })));
};

GitHubIcon.propTypes = {
  size: oneOfType([number, arrayOf(number)]),
  title: string
};

var TwitterIcon = function TwitterIcon(_ref) {
  var size = _ref.size,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["size", "title"]);

  return React.createElement(Icon, _extends({}, props, {
    size: size,
    "aria-label": "Twitter icon"
  }), React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    height: "100%",
    width: "100%",
    fill: "currentColor",
    viewBox: "0 0 24 20"
  }, title && React.createElement("title", null, title), React.createElement("path", {
    d: "M23.954 2.56897C23.069 2.95797 22.124 3.22297 21.129 3.34397C22.143 2.73297 22.923 1.76997 23.292 0.620972C22.341 1.17597 21.287 1.57997 20.165 1.80497C19.269 0.845972 17.992 0.245972 16.574 0.245972C13.857 0.245972 11.654 2.44897 11.654 5.16297C11.654 5.55297 11.699 5.92797 11.781 6.28697C7.691 6.09397 4.066 4.12997 1.64 1.16097C1.213 1.88297 0.974 2.72197 0.974 3.63597C0.974 5.34597 1.844 6.84897 3.162 7.73197C2.355 7.70597 1.596 7.48397 0.934 7.11597V7.17697C0.934 9.56197 2.627 11.551 4.88 12.004C4.467 12.115 4.031 12.175 3.584 12.175C3.27 12.175 2.969 12.145 2.668 12.089C3.299 14.042 5.113 15.466 7.272 15.506C5.592 16.825 3.463 17.611 1.17 17.611C0.78 17.611 0.391 17.588 0 17.544C2.189 18.938 4.768 19.753 7.557 19.753C16.611 19.753 21.556 12.257 21.556 5.76697C21.556 5.55797 21.556 5.34697 21.541 5.13697C22.502 4.44797 23.341 3.57697 24.001 2.58897L23.954 2.56897Z"
  })));
};

TwitterIcon.propTypes = {
  size: oneOfType([number, arrayOf(number)]),
  title: string
};

var SmartLink = function SmartLink(_ref) {
  var children = _ref.children,
      href = _ref.href,
      label = _ref.label,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'primary' : _ref$variant,
      props = _objectWithoutProperties(_ref, ["children", "href", "label", "variant"]);

  var internal = /^\/(?!\/)/.test(href);

  var _useThemeUI = useThemeUI(),
      theme = _useThemeUI.theme;

  if (internal) {
    return React.createElement(Link, _extends({}, props, {
      as: theme.link.internal,
      href: href,
      "aria-label": label,
      variant: variant
    }), children);
  }

  return React.createElement(Link, _extends({}, props, {
    as: theme.link.external,
    href: href,
    variant: variant
  }), children);
};

var variants = ['primary', 'secondary', 'inherit'];
var variantType = oneOf(variants);
var linkType = shape({
  text: string.isRequired,
  href: string.isRequired,
  label: string
});
SmartLink.propTypes = {
  children: node.isRequired,
  href: string.isRequired,
  label: string,
  variant: variantType
};
var lookup = {
  twitter: {
    url: function url(username) {
      return "https://twitter.com/".concat(username);
    },
    Icon: TwitterIcon
  },
  github: {
    url: function url(username) {
      return "https://github.com/".concat(username);
    },
    Icon: GitHubIcon
  },
  email: {
    url: function url(username) {
      return "mailto:".concat(username);
    },
    Icon: EmailIcon
  }
};

var SocialIcons = function SocialIcons(_ref) {
  var platforms = _ref.platforms,
      size = _ref.size,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'primary' : _ref$variant,
      props = _objectWithoutProperties(_ref, ["platforms", "size", "variant"]);

  return React.createElement(Flex, _extends({}, props, {
    sx: {
      flexWrap: 'wrap',
      justifyContent: 'center',
      alignItems: 'center'
    }
  }), platforms.map(function (_ref2) {
    var id = _ref2.id,
        username = _ref2.username,
        title = _ref2.title;
    var _lookup$id = lookup[id],
        url = _lookup$id.url,
        Icon = _lookup$id.Icon;
    return React.createElement(SmartLink, {
      key: id,
      href: url(username),
      variant: variant,
      mx: 2
    }, React.createElement(Icon, {
      size: size,
      title: title
    }));
  }));
};

SocialIcons.propTypes = {
  // Array defines sequence in which social icons are displayed.
  platforms: arrayOf(shape({
    id: string.isRequired,
    username: string.isRequired,
    title: string.isRequired
  })).isRequired,
  size: oneOfType([number, arrayOf(number)]),
  variant: oneOf(['primary', 'secondary', 'inherit'])
}; // Badges need a variant to display properly in all circumstances.

var ProfilePreview = function ProfilePreview(_ref) {
  var _ref$align = _ref.align,
      align = _ref$align === void 0 ? 'center' : _ref$align,
      _ref$fontSize = _ref.fontSize,
      fontSize = _ref$fontSize === void 0 ? [3, 4] : _ref$fontSize,
      profile = _ref.profile,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'primary' : _ref$variant,
      props = _objectWithoutProperties(_ref, ["align", "fontSize", "profile", "variant"]);

  return React.createElement(Flex, _extends({}, props, {
    sx: {
      flexDirection: 'column',
      alignItems: normalizeAlign(align),
      fontFamily: 'body'
    }
  }), profile.avatar, profile.honorific && React.createElement(Text, {
    sx: {
      fontSize: 1,
      lineHeight: 'body',
      textAlign: align
    }
  }, profile.honorific), React.createElement(Text, {
    as: "h1",
    sx: {
      fontSize: fontSize,
      lineHeight: 'heading',
      textAlign: align,
      mt: 0,
      mb: 0
    }
  }, profile.name), profile.jobtitle && React.createElement(Text, {
    sx: {
      fontSize: 2,
      lineHeight: 'body',
      textAlign: align
    }
  }, profile.jobtitle), profile.organization && React.createElement(Text, {
    sx: {
      fontSize: 2,
      fontWeight: 'bold',
      lineHeight: 'body',
      textAlign: align
    }
  }, profile.organization), profile.socialIcons && React.createElement(SocialIcons, {
    platforms: profile.socialIcons,
    size: 32,
    variant: "inherit"
  }), profile.badges && React.createElement(Badges, {
    values: profile.badges,
    variant: variant,
    mt: 2
  }));
};

var alignments$1 = ['start', 'center', 'end'];
var alignType$1 = oneOf(alignments$1);
ProfilePreview.propTypes = {
  align: oneOfType([alignType$1, arrayOf(alignType$1)]),
  fontSize: oneOfType([number, arrayOf(number)]),
  profile: shape({
    avatar: node.isRequired,
    honorific: string,
    name: string,
    jobtitle: string,
    organization: string,
    socialIcons: arrayOf(shape({
      id: string.isRequired,
      username: string.isRequired,
      title: string
    }).isRequired),
    badges: arrayOf(string)
  }).isRequired,
  variant: string
};

var Avatars = function Avatars(_ref) {
  var values = _ref.values,
      _ref$align = _ref.align,
      align = _ref$align === void 0 ? 'start' : _ref$align,
      props = _objectWithoutProperties(_ref, ["values", "align"]);

  return React.createElement(Grid, _extends({}, props, {
    gap: 2,
    sx: {
      gridTemplateColumns: 'repeat(auto-fit, 96px)',
      justifyItems: align,
      justifyContent: align,
      // Stretch to full width in scenarios where Avatars is used inside Flex.
      alignSelf: 'stretch'
    }
  }), values.map(function (_ref2) {
    var id = _ref2.id,
        avatar = _ref2.avatar,
        name = _ref2.name,
        href = _ref2.href;
    return React.createElement(SmartLink, {
      key: id,
      css: {
        ':hover': {
          textDecoration: 'none'
        }
      },
      href: href,
      variant: "inherit"
    }, React.createElement(ProfilePreview, {
      profile: {
        avatar: avatar,
        name: name
      },
      fontSize: 1,
      align: align
    }));
  }));
};

var alignments$2 = ['start', 'center', 'end'];
var alignType$2 = oneOf(alignments$2);
Avatars.propTypes = {
  values: arrayOf(shape({
    id: string.isRequired,
    avatar: node.isRequired,
    name: string,
    href: string.isRequired
  })).isRequired,
  align: oneOfType([alignType$2, arrayOf(alignType$2)])
};

var ColorCard = function ColorCard(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'primary' : _ref$color,
      title = _ref.title,
      subtitle = _ref.subtitle,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["color", "title", "subtitle", "children"]);

  return React.createElement(Box, _extends({}, props, {
    sx: {
      border: '1px solid',
      borderColor: color
    }
  }), React.createElement(Box, {
    sx: {
      p: [2, 3],
      mb: [2, 3]
    },
    variant: "pairings.".concat(color)
  }, title, subtitle && subtitle), React.createElement(Box, {
    sx: {
      px: [2, 3],
      mb: [2, 3]
    }
  }, children));
};

ColorCard.propTypes = {
  color: string,
  // Bring your own heading (based on the context this is rendered in).
  title: node.isRequired,
  subtitle: node,
  children: node.isRequired
}; // What the title prop renders (heading) may have no top margin, only bottom margin.
// What the description prop renders (paragraph) may have no top margin, only bottom margin.

var EventPreview = function EventPreview(_ref) {
  var event = _ref.event,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'primary' : _ref$variant,
      props = _objectWithoutProperties(_ref, ["event", "variant"]);

  return React.createElement(Flex, _extends({}, props, {
    sx: {
      flexDirection: 'column',
      alignItems: 'flex-start',
      fontFamily: 'body'
    }
  }), event.tag && React.createElement(Badges, {
    values: [event.tag],
    variant: variant,
    mb: 1
  }, event.tag), event.title, event.speakers && event.speakers, React.createElement(Text, {
    as: "time",
    sx: {
      display: 'block',
      textAlign: 'start',
      mb: event.description || event.href || event.registrationLink ? 3 : 0
    }
  }, "".concat(event.date, " (").concat(event.duration, ")")), event.description && event.description, (event.href || event.registrationLink) && React.createElement(Flex, {
    sx: {
      flexGrow: 1,
      flexDirection: 'row',
      flexWrap: 'wrap',
      alignItems: 'flex-end'
    }
  }, event.href && React.createElement(Button, {
    as: SmartLink,
    sx: {
      // Right margin only if there is a registration button.
      mr: event.registrationLink ? [2, 3] : 0
    },
    href: event.href,
    variant: variant
  }, "Details"), event.registrationLink && React.createElement(Button, {
    as: SmartLink,
    href: event.registrationLink,
    variant: "buttons.outline.".concat(variant)
  }, "Register")));
};

EventPreview.propTypes = {
  event: shape({
    tag: string,
    title: node.isRequired,
    date: string.isRequired,
    duration: string.isRequired,
    speakers: node,
    description: node,
    href: string,
    registrationLink: string
  }).isRequired,
  variant: string
};

var Footer = function Footer(_ref) {
  var logo = _ref.logo,
      title = _ref.title,
      socialIcons = _ref.socialIcons,
      links = _ref.links,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'primary' : _ref$variant;
  return React.createElement(Box, {
    sx: {
      variant: "pairings.".concat(variant)
    }
  }, React.createElement(Container, {
    sx: {
      maxWidth: 'width.wide',
      px: [2, 3, 4],
      py: 4
    }
  }, React.createElement(Flex, {
    as: "footer",
    sx: {
      flexDirection: 'column',
      alignItems: 'center'
    }
  }, logo && React.createElement(SmartLink, {
    href: "/",
    variant: "inherit",
    height: "100%",
    mb: [1, 2]
  }, logo), title && React.createElement(SmartLink, {
    href: "/",
    variant: "inherit"
  }, React.createElement(Heading, {
    sx: {
      whiteSpace: 'nowrap',
      fontFamily: 'heading',
      fontSize: [3, 4, 5],
      mb: [2, 3]
    }
  }, title)), socialIcons, React.createElement(Flex, {
    sx: {
      flexWrap: 'wrap',
      justifyContent: 'center'
    }
  }, links.map(function (link) {
    return React.createElement(SmartLink, {
      href: link.href,
      key: link.href,
      px: [2, 3],
      py: [1, 2],
      variant: "inherit"
    }, React.createElement(Text, {
      sx: {
        fontFamily: 'body',
        textAlign: 'center'
      }
    }, link.text));
  })))));
};

Footer.propTypes = {
  logo: node,
  title: string,
  socialIcons: node,
  links: arrayOf(linkType).isRequired,
  variant: oneOf(['primary', 'secondary'])
};
var Context = React.createContext({});

var Header = function Header(_ref) {
  var logo = _ref.logo,
      title = _ref.title,
      links = _ref.links,
      button = _ref.button,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? [48, 64, 80] : _ref$height,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'branded' : _ref$variant,
      props = _objectWithoutProperties(_ref, ["logo", "title", "links", "button", "height", "variant"]);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      menuOpen = _useState2[0],
      setMenuOpen = _useState2[1];

  return React.createElement(Context.Provider, {
    value: {
      menuOpen: menuOpen,
      setMenuOpen: setMenuOpen
    }
  }, React.createElement(Container, _extends({}, props, {
    sx: {
      maxWidth: 'width.wide',
      px: [2, 3, 4],
      py: [2, 3],
      variant: "pairings.".concat(variant)
    }
  }), React.createElement(Flex, {
    as: "header",
    sx: {
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'center',
      height: height
    }
  }, logo && React.createElement(SmartLink, {
    sx: {
      height: '100%',
      flexShrink: 0,
      mr: [2, 3]
    },
    href: "/",
    "aria-label": "Back to homepage",
    variant: "inherit"
  }, logo), title && React.createElement(SmartLink, {
    sx: {
      flexGrow: 0,
      flexShrink: 0,
      mr: [0, 3, 4]
    },
    href: "/",
    "aria-label": "Back to homepage",
    variant: "inherit"
  }, React.createElement(Heading, {
    sx: {
      whiteSpace: 'nowrap}',
      fontSize: [4, 5, 6]
    }
  }, title)), React.createElement(Box, {
    as: "nav",
    sx: {
      display: [menuOpen ? 'flex' : 'none', 'flex'],
      flexDirection: ['column', 'row'],
      justifyContent: ['flex-start', 'flex-end'],
      alignItems: 'center',
      flexGrow: 1,
      flexShrink: 1,
      position: ['fixed', 'static'],
      overflow: 'auto',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      zIndex: 2,
      variant: "pairings.".concat(variant)
    }
  }, React.createElement(Box, {
    "aria-label": "Close navigation",
    sx: {
      display: ['block', 'none'],
      height: height,
      width: '100%',
      textAlign: 'right',
      p: 2,
      my: 2
    },
    onClick: function onClick() {
      setMenuOpen(false);
    }
  }, React.createElement(Close, {
    css: {
      WebkitTapHighlightColor: 'transparent'
    }
  })), React.createElement(Flex, {
    sx: {
      flexDirection: ['column', 'row'],
      alignItems: 'center',
      overflow: 'auto'
    }
  }, React.createElement(SmartLink, {
    key: "/",
    sx: {
      display: ['flex', 'none'],
      fontFamily: 'body',
      fontSize: [4, 3, 4],
      fontWeight: 'bold',
      mb: [4, 0],
      ml: [0, 3, 4]
    },
    href: "/",
    label: "Back to homepage",
    variant: "inherit"
  }, "Home"), links.map(function (_ref2) {
    var href = _ref2.href,
        text = _ref2.text,
        label = _ref2.label;
    return React.createElement(SmartLink, {
      key: href,
      sx: {
        flexShrink: 0,
        fontFamily: 'body',
        fontSize: [4, 3, 4],
        fontWeight: 'bold',
        mb: [4, 0],
        ml: [0, 3, 4]
      },
      href: href,
      label: label,
      variant: "inherit"
    }, text);
  })), button && React.createElement(Button, {
    variant: "outline.primary",
    as: SmartLink,
    sx: {
      flexGrow: 0,
      flexShrink: 0,
      fontFamily: 'body',
      fontSize: [4, 3, 4],
      color: 'inherit',
      my: [4, 0],
      ml: [0, 3, 4]
    },
    href: button.href,
    label: button.label
  }, button.text)), React.createElement(Box, {
    "aria-label": "Open navigation",
    sx: {
      display: ['block', 'none'],
      flexGrow: 1,
      flexShrink: 1,
      height: '100%',
      textAlign: 'right',
      py: 2,
      zIndex: 1
    },
    onClick: function onClick() {
      setMenuOpen(true);
    }
  }, React.createElement(MenuButton, {
    css: {
      WebkitTapHighlightColor: 'transparent'
    },
    "aria-label": "Open navigation"
  })))));
};

Header.propTypes = {
  logo: node,
  title: string,
  links: arrayOf(linkType).isRequired,
  button: linkType,
  height: oneOfType([number, arrayOf(number), string, arrayOf(string)]),
  variant: oneOf(['branded', 'primary'])
};

var Names = function Names(_ref) {
  var values = _ref.values,
      _ref$align = _ref.align,
      align = _ref$align === void 0 ? 'start' : _ref$align,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'body' : _ref$variant,
      props = _objectWithoutProperties(_ref, ["values", "align", "variant"]);

  return React.createElement(Text, _extends({
    as: "div"
  }, props, {
    sx: {
      fontFamily: 'body',
      lineHeight: 'body',
      textAlign: align
    },
    variant: "names.".concat(variant)
  }), values.join(', '));
};

var alignments$3 = ['start', 'center', 'end'];
var alignType$3 = oneOf(alignments$3);
var variantType$1 = oneOf(['default', 'bold']);
Names.propTypes = {
  values: arrayOf(string).isRequired,
  align: oneOfType([alignType$3, arrayOf(alignType$3)]),
  variant: variantType$1
};

var NewTabLink = function NewTabLink(_ref) {
  var children = _ref.children,
      href = _ref.href,
      className = _ref.className;
  return React.createElement("a", {
    className: className,
    href: href,
    target: "_blank",
    rel: "noreferrer noopener"
  }, children);
};

NewTabLink.propTypes = {
  children: node.isRequired,
  href: string.isRequired,
  className: string
}; // What the title prop renders (heading) may have no top margin, only bottom margin.
// What the description prop renders (paragraph) may have no top or bottom margin.

var PostPreview = function PostPreview(_ref) {
  var post = _ref.post,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'primary' : _ref$variant,
      props = _objectWithoutProperties(_ref, ["post", "variant"]);

  var mb = post.description ? 3 : 0;
  return React.createElement(Flex, _extends({}, props, {
    sx: {
      flexDirection: 'column',
      fontFamily: 'body'
    }
  }), post.title, post.authors && post.authors, React.createElement(Text, {
    as: "time",
    sx: {
      display: 'block',
      mb: mb
    }
  }, post.date), post.description && post.description, post.href && React.createElement(Flex, {
    sx: {
      flexGrow: 1,
      flexDirection: 'column',
      justifyContent: 'flex-end'
    }
  }, React.createElement(Button, {
    as: SmartLink,
    sx: {
      alignSelf: ['stretch', 'flex-start'],
      whiteSpace: 'nowrap',
      mt: 3
    },
    href: post.href,
    variant: variant
  }, "Read on")));
};

PostPreview.propTypes = {
  post: shape({
    title: node.isRequired,
    date: string.isRequired,
    authors: node,
    description: node,
    href: string
  }).isRequired,
  variant: string
}; // To add spacing around videos use Container or Box.
// Player parameters: https://developers.google.com/youtube/player_parameters.

var Video = function Video(_ref) {
  var id = _ref.id,
      title = _ref.title,
      _ref$ratio = _ref.ratio,
      ratio = _ref$ratio === void 0 ? 16 / 9 : _ref$ratio;
  return React.createElement(AspectRatio, {
    ratio: ratio
  }, React.createElement("iframe", {
    width: "100%",
    height: "100%",
    src: "https://www.youtube-nocookie.com/embed/".concat(id, "?rel=0"),
    title: title,
    frameBorder: "0",
    allow: "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
    allowFullScreen: true
  }));
};

Video.propTypes = {
  id: string.isRequired,
  title: string.isRequired,
  ratio: number
};
export { Avatars, Badges, ColorCard, EventPreview, Footer, Header, Names, NewTabLink, PostPreview, ProfilePreview, SmartLink, SocialIcons, Video, EmailIcon, GitHubIcon, TwitterIcon };